import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'dashToSpace',
    standalone: false,
})
export class DashToSpacePipe implements PipeTransform {
    transform(value: string): string {
        return value.replace(/\s+/g, '-').toUpperCase();
    }
}
